//Componentes generales
import React, { useReducer } from "react";
import subcuentasReducer from "./subcuentasReducer";
import subcuentasContext from "./subcuentasContext";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getDimensiones, getSubcuentas, uploadSubcuenta } from "../../api/subcuenta"

//Acciones
import { 
    ACTUALIZAR_DIMENSIONES,
    ACTUALIZAR_SUBCUENTAS,
    ACTUALIZAR_SUBCUENTAS_DB,
    CARGANDO_SUBCUE,
    ERROR_SUBCUE,
    LIMPIAR_ERROR
} from "./subcuentasActions";

/* 
    State encargado de la gestión de subcuentas.
*/
const SubcuentasState = props => {

    //Valores iniciales
    const initialState = {
        dimensiones: [],
        subcuentas: [],
        cargando: false,
        error: ""
    };

    const [state, dispatch] = useReducer(subcuentasReducer, initialState);

    /* 
        Función recuperar los subcuentas y a su vez actualizarlas.
    */
    const actualizarSubcuentas = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR SUBCUENTAS");
            const resp = await getSubcuentas();
            dispatch({
                type: ACTUALIZAR_SUBCUENTAS,
                payload: resp.data.data
            })
            console.log("RESPUESTA DE SUBCUENTAS SQL",resp)
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

        const actualizarDimensiones = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR DIMENSIONES");
            const resp = await getDimensiones();
            dispatch({
                type: ACTUALIZAR_DIMENSIONES,
                payload: resp.data.data
            })
            console.log("RESPUESTA DE DIMENSIONES",resp)
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la tabla de subcuentas con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarSubcuentasDB = async (userID, userName) => {

        try{
            console.log("ENTRO AL ACTUALIZAR SUBCUENTAS DB");
            await uploadSubcuenta(userID, userName);
            const resp = await getSubcuentas();
            dispatch({
                type: ACTUALIZAR_SUBCUENTAS_DB,
                payload: resp.data.data
            });
            console.log("RESPUESTA DE SUBCUENTAS MONGO",resp)
        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            dispatch({
                type: ERROR_SUBCUE,
                payload: error.response.data.errMsg
            });

            return {status: false, msg: error.response.data.errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_SUBCUE
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <subcuentasContext.Provider
            value={{
                dimensiones: state.dimensiones,
                subcuentas: state.subcuentas,
                isCargando: state.cargando,
                error: state.error,
                actualizarSubcuentas,
                actualizarDimensiones,
                actualizarSubcuentasDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </subcuentasContext.Provider>
    )
    
}

export default SubcuentasState;